<template>
  <div
    :class="[
      'box-viewmore',
      {
        open
      }
    ]"
  >
    <div v-if="title" class="title-box v-line">
      <h2>{{ title }}</h2>
    </div>
    <div class="box-content" id="box" ref="box" v-if="isHidden">
      <slot id="content" />
    </div>
    <div class="box-content-hidden" id="box" ref="box" v-else>
      <slot id="content" />
    </div>
    <div class="flex justify-center">
      <button class="btn-viewmore" @click="open = !open" v-if="isHidden">
        <span>{{ getExpandLabel }}</span>
        <i
          class="icon icon-bor-triangle-down text-primary"
          :class="{ rotate: this.open }"
        />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: ['title', 'height'],
  data() {
    return {
      open: false,
      isHidden: true
    }
  },
  mounted() {
    this.getHeight()
  },
  computed: {
    getExpandLabel() {
      return this.open ? '折りたたむ' : 'もっと見る'
    }
  },
  methods: {
    getHeight() {
      const heightOfBox = this.$refs.box.clientHeight
      if (heightOfBox < 150) {
        this.isHidden = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
